// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
export const REQUIRED_ERROR = 'Field is required';
export const PASSWORD_KIND = {
    SIGNIN: 'signin',
    SIGNUP: 'signup',
};
